import * as React from 'react';
import styled from 'styled-components';
import axios , {AxiosResponse} from "axios";
import * as ethers from 'ethers';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { v5ApiBaseUrl } from '../../../core/api';
import { addressInputDisableState } from '../../../states/addressInputDisableState';
import { configJsonState } from '../../../states/configJsonState';
import { getedNFTState } from '../../../states/getedNFTState';
import { nftJsonNoneMetaState } from '../../../states/nftJsonNoneMetaState';
import { nftJsonState } from '../../../states/nftJsonState';
import { nftMintState } from '../../../states/nftMintState';
import { overLimitPerWalletState } from '../../../states/overLimitPerWalletState';
import { requestIdState } from '../../../states/requestIdState';
import { sameRequestIdState } from '../../../states/sameRequestIdState';

//配布リクエスト後のNFT受信チェック
export const useNFTReceiveCheck = (walletAddress: string) => {

    const [nftMintStatus ,setNftMintStatus] = useRecoilState(nftMintState);
    const nav = useNavigate();
    const nftInfoNoneMeta = useRecoilValue(nftJsonNoneMetaState);
    const requestIdStatus = useRecoilValue(requestIdState);
    const overLimitPerWalletStatus = useRecoilValue(overLimitPerWalletState);
    const [addressInputDisableStatus ,setAddressInputDisableStatus] = useRecoilState(addressInputDisableState);
    const [sameRequestIdStatus , setSameRequestIdStatus] = useRecoilState(sameRequestIdState);
    const configStatus = useRecoilValue(configJsonState);
    const [getedNFTStatus , setGetedNFTStatus ] = useRecoilState(getedNFTState);


    React.useEffect(() => {
        setAddressInputDisableStatus(false);

        if (sameRequestIdStatus === `yes`) {
            nav('/13');
            return;
        }
        if (nftMintStatus === `done`) {
            //ブラウザバックされた場合
            nav('/8');
            return;
        }
        if (overLimitPerWalletStatus === `yes`) {
            nav(`/11`);
            return;
        }

        const delayFunc = setTimeout(async() => { 
            let nftcontract:ethers.ethers.Contract;
            let nftBalanceOf:any;
            let provider:ethers.ethers.providers.JsonRpcProvider;
            let checkedWalletAddress:string;
            let txReceipt:ethers.ethers.providers.TransactionReceipt;
            let answer:AxiosResponse;
            let checkTxHash = ``;

            if (!(walletAddress)) {
                //リロードされた場合
                checkedWalletAddress = localStorage.getItem('currentwalletAddress');
            }else if(walletAddress){
                checkedWalletAddress = walletAddress;
            }

            //---------------txHash取得（NFTミント判定に使用)---------------
            console.log(`post txHash`);

            while (checkTxHash === ``) {
                answer = await axios.get(`${v5ApiBaseUrl}/dist/nft-shot/txhash`, {
                    params:{
                    requestId: requestIdStatus,
                    }
                }).catch((err) => {
                    return err
                });
                console.log(answer);
                checkTxHash =  answer.data;
                await new Promise(resolve => setTimeout(resolve, 2000));
            }

            if (!(answer.request.status == 201 || answer.request.status == 200)) {
                alert(`post txhash error ${answer.request.status}`);
                nav('/14');
                return;
            }else if(answer.data === `dropped`){
                nav('/14');
                return;
            }

            console.log(`check_contractAddress : ${nftInfoNoneMeta.contractaddress}`);
            console.log(`check_walletAddress : ${checkedWalletAddress}`);
            provider =  new ethers.providers.JsonRpcProvider(nftInfoNoneMeta.chainRPCEndpoint);
            nftcontract =  new ethers.Contract( nftInfoNoneMeta.contractaddress, JSON.parse(nftInfoNoneMeta.nftabi), provider );

            //---------------txHashを使用したミント判定---------------
            try {
                await provider.waitForTransaction(`${answer.data}`,1,100000)
                    .then(async function(value) {
                    txReceipt = value;
                    nftBalanceOf = await nftcontract.balanceOf(checkedWalletAddress);
                })
                console.log(txReceipt);
            } catch(error) {
                console.log(error);
                console.log(`waitForTransaction() error`);
                alert(`invalid txhash error`);
                nav('/14');
                return;
            }
            let nftHoldings:number = parseInt(nftBalanceOf.toString());
            console.log(`checkNFTHoldings.....walletAddress:${checkedWalletAddress} holdings:${nftHoldings}`);



            if (txReceipt.status === 1) {
                //-------------配布完了処理----------
                const nftid = await nftcontract.tokenOfOwnerByIndex(checkedWalletAddress, nftHoldings-1);
                let uri = await nftcontract.tokenURI(nftid);
                let uriFromIPFS = [];
                console.log(`nftid : ${nftid}`);
                console.log(`uri : ${uri}`);

                if(uri.indexOf('ipfs://') != -1){
                    let ipfsID:string = uri.replace("ipfs://", "");
                    uriFromIPFS.push(`https://sushitop.mypinata.cloud/ipfs/${ipfsID}`);
                    let ipfsIDFromNftStorage:string[] = ipfsID.split(`/`);
                    uriFromIPFS.push(`https://${ipfsIDFromNftStorage[0]}.ipfs.nftstorage.link/${ipfsIDFromNftStorage[1]}`);
                }
                //🔴httpsではなく,httpの場合だとクロム上でエラーが起きるので回避が必要
                if (uri.indexOf('http://') != -1) {
                    uri = uri.replace('http://','https://');
                }
                if (uri.indexOf('ar://') != -1) {
                    uri = uri.replace('ar://','https://arweave.net/');
                }

                let res:Response;
                let json:any;
                if (uriFromIPFS.length !== 0) {
                    for (let index = 0; index < uriFromIPFS.length; index++) {
                        try {
                            res = await fetch(uriFromIPFS[index]);
                            json = await res.json();
                            break;
                        } catch (error) {
                            console.log(error);
                            continue;
                        }
                    }
                }else{
                    try {
                        res = await fetch(uri);
                        json = await res.json();
                    } catch (error) {
                        console.log(`fetch error`);
                        console.log(error);
                    }
                }

                console.log(json);
                let url2:string = json.image;


                //🌟ここでtopicon.pngのpathかtokeURIから取得したURLをセットするか条件分岐
                if (!url2) {
                    //パラメータにimageがないパターン,同階層のtopicon.pngのpathをセット
                    localStorage.setItem('NFTImageURL',`${nftInfoNoneMeta.image}`);
                }else if(url2.indexOf('ipfs://') != -1){
                    //🌟ipfsURLの場合の条件分岐必要
                    let ipfsID:string = url2.replace("ipfs://", "");
                    localStorage.setItem('NFTImageURL',`https://sushitop.mypinata.cloud/ipfs/${ipfsID}`);
                    url2 = `https://sushitop.mypinata.cloud/ipfs/${ipfsID}`;
                }else if(url2.indexOf('ar://') != -1){
                    localStorage.setItem('NFTImageURL',`${url2.replace('ar://','https://arweave.net/')}`);
                    url2 = url2.replace('ar://','https://arweave.net/');
                }
                else{
                    //🌟arweaveURL(https://arweave.net/)の場合
                    localStorage.setItem('NFTImageURL',`${url2}`);
                }

                setGetedNFTStatus(
                    {
                        name:json.name,
                        description:json.description,
                        external_url:json.external_url,
                        image:url2,
                        tokenId:nftid.toString(),
                        chainId:nftInfoNoneMeta.chainId,
                    }
                );
                setNftMintStatus(`done`);

                if (configStatus.isGachaMovie === `yes`) {
                    nav('/movie');
                }else{
                    nav('/8');
                }
            }else{
                //-------------配布失敗処理----------
                nav('/14');
            }
        }, 20000);
    }, []);
  
    return { getedNFTStatus, nftMintStatus };
  

};